import { accessRole } from "../../../../../helpers/access_role"
import { config } from "../../../../../helpers/config_global"
import React, { useState, Component, Fragment } from "react"
import { Redirect } from "react-router-dom"

import { Tooltip } from "reactstrap"

import MKIDatatable from '../../../../../modules/mki-datatable/lib'
import { ConfirmAlert } from '../../../../../helpers/ui/alert'

import { cancelToken } from "../../../../../services/adapters/kepegawaian/riwayatjabatanService"

import DataTableBloc from '../Blocs/DataTableBloc'
import apiResponse from '../../../../../services/apiResponse'

import moment from "moment"

class TableActiveComponent extends Component {
    dataTableBloc = new DataTableBloc();

    currentRoleId = JSON.parse(localStorage.getItem('currentRoleId'));

    // Retrieve Data Pegawai by Admin / Pegawai
    userdata = JSON.parse(localStorage.getItem('userdata'));
    employeeSeleted = JSON.parse(localStorage.getItem('employeeSelected'));
    peg_uuid = !accessRole('approve') ? (this.userdata != null ? this.userdata.employee_uuid : "")
        : (this.employeeSeleted != null ? this.employeeSeleted.employee_uuid : "")

    source
    historyTable = 'historyriwayatjabatanTableActive'
    defaultOrder = 'position_history_decree_date'
    defaultSize = 10
    defaultSort = 'desc'
    configDatatable = {
        ...config('datatable'),
        sort: {
            column: this.defaultOrder,
            order: this.defaultSort
        }
    }

    modal_confirm_status = 0
    modal_confirm_message = ""
    modal_confirm_sucess_message = "data berhasil di nonaktifkan"
    modal_confirm_error_message = "data gagal di nonaktifkan"

    constructor(props) {
        super(props)
        this.state = {
            tooltip: false,
            detailUuid: null,
            updateUuid: null,
            inactiveUuid: null,
            defaultSize: 10,
            rows: [],
            totalRow: 0,
            loadingTable: true,
            filter: sessionStorage.getItem(this.historyTable) ?
                JSON.parse(sessionStorage.getItem(this.historyTable)) :
                {
                    filter_value: "",
                    page_number: 1,
                    page_size: this.defaultSize,
                    sort_order: {
                        column: this.defaultOrder,
                        order: this.defaultSort
                    }
                }
        }
    }
    toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

    dateParse = (input) => {
        let res = "-";
        if (input != "" && input != null) {
            res = moment(input).format('DD/MM/YYYY')
        }
        return res;
    }

    loadData = async () => {
        /* history Datatable */
        sessionStorage.setItem(this.historyTable, JSON.stringify(this.state.filter))

        /* kirim ke server */
        let offset = (this.state.filter.page_number - 1) * this.state.filter.page_size
        if (this.state.defaultSize !== this.state.filter.page_size) {
            this.setState({
                defaultSize: this.state.filter.page_size
            })
            offset = 0
            this.configDatatable.page_number = 1
        }
        const query = {
            search: this.state.filter.filter_value,
            limit: this.state.filter.page_size,
            offset: offset,
            order: this.state.filter.sort_order.column,
            sort: this.state.filter.sort_order.order,
            status: 1,
            pegawai_uuid: this.peg_uuid
        }
        await this.dataTableBloc.fetchRowTable(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadData()
    }

    confirmResponse = (response) => {
        let forState = {}
        switch (response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                let data_status = parseInt(this.modal_confirm_status)
                if (data_status === 1) {
                    this.inactiveData()
                } else {
                    this.activeData()
                }
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
            case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:
        }
        this.setState(forState)
    }

    inactiveData = async () => {
        await this.dataTableBloc.fetchInactive({ uuid: this.state.inactiveUuid })
    }

    activeData = async () => {
        await this.dataTableBloc.fetchActive({ uuid: this.state.inactiveUuid })
    }

    componentDidMount() {
        this.setTokenAPI()

        this.dataTableBloc.rowtableChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingTable: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingTable: true
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    this.setState({
                        totalRow: response.total,
                        rows: response.result,
                        loadingTable: false
                    })
                    break
                case apiResponse.ERROR:

                    break
                default:
                    break
            }
        })

        this.dataTableBloc.inactiveChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                        loadingTable: true
                    }, function () {
                        this.setTokenAPI()
                        this.props.handleInactiveSuccess()
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.dataTableBloc.activeChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                        loadingTable: true
                    }, function () {
                        this.setTokenAPI()
                        this.props.handleInactiveSuccess()
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })


    }

    componentWillUnmount() {
        this.dataTableBloc.rowtableChannel?.unsubscribe()
    }

    columns = [
        {
            key: "position_history_decree_number",
            text: "Nomor SK",
            className: "position_history_decree_number",
            sortable: true,
            width: '20%',
            cell: record => {
                return (
                    <span>
                        <label>{record?.position_history_decree_number || "-"}</label><br />
                        <label>{record?.position_history_decree_date ? this.dateParse(record?.position_history_decree_date) : "-"}</label>
                    </span>
                )
            }
        },
        {
            key: "position_history_tmt_position_date",
            text: "Tanggal TMT Mulai",
            className: "position_history_tmt_position_date",
            sortable: true,
            width: '20%',
            cell: record => {
                return this.dateParse(record.position_history_tmt_position_date);
            }
        },
        {
            key: "position_history_end_date_tmt",
            text: "Tanggal TMT Berakhir",
            className: "position_history_end_date_tmt",
            sortable: true,
            width: '20%',
            cell: record => {
                return this.dateParse(record.position_history_end_date_tmt);
            }
        },
        {
            key: "position_history_work_unit_to_name",
            text: "Unit Kerja Tujuan",
            className: "position_history_work_unit_to_name",
            sortable: true,
            width: '20%'
        },
        {
            key: "position_history_position_name",
            text: "Nama Jabatan",
            className: "position_history_position_name",
            sortable: true,
            width: '20%',
            cell: record => {
                return (
                    <span>
                        <label>{record?.position_history_position_name || "-"}</label>
                        {record?.employee_status_name && (
                            <>
                                <br />
                                <label>({record?.employee_status_name})</label>
                            </>
                        )}
                    </span>
                )
            }
        },
        {
            key: "echelon_name",
            text: "Eselon/Jenjang",
            className: "echelon_name",
            sortable: true,
            width: '20%'
        },
        {
            key: "position_grade",
            text: "Grade",
            className: "position_grade",
            sortable: true,
            width: '20%'
        },
        {
            key: "position_history_is_pltplh",
            text: "PLT/PLH",
            className: "position_history_is_pltplh",
            sortable: true,
            cell: record => {
                var status = record.position_history_is_pltplh
                var PLTPLHName = '-';
                if (parseInt(status) == 1) {
                    PLTPLHName = 'PLT';
                } else if (parseInt(status) == 2) {
                    PLTPLHName = 'PLH';
                }
                return (
                    <span>
                        {<label className="badge rounded-pill bg-soft-success font-size-12" >{PLTPLHName}</label>}
                    </span>
                )
            }
        },
        {
            key: "position_history_status",
            text: "Status",
            className: "position_history_status",
            sortable: true,
            cell: record => {
                var status = record.position_history_status
                return (
                    <span>
                        {parseInt(status) == 1 ? <label className="badge rounded-pill bg-soft-success font-size-12" >Aktif</label> : <label><label className="badge rounded-pill bg-soft-danger font-size-12" >Tidak Aktif</label></label>}
                    </span>
                )
            }
        },
        {
            key: "action",
            text: "Action",
            className: "action",
            width: 120,
            sortable: false,
            align: 'center',
            cell: record => {
                const thisId = record.position_history_uuid
                var status = record.position_history_status
                return (
                    <Fragment>
                        <span>
                            <button
                                className="btn btn-primary btn-sm"
                                id={"detail-" + thisId}
                                onClick={() => {
                                    this.setState({
                                        detailUuid: record.position_history_uuid
                                    })
                                }}
                                style={{
                                    marginRight: '2px',
                                    padding: '2px 5px'
                                }}>
                                <i className="uil-align-left"></i>
                            </button>
                            <Tooltip
                                style={{
                                    marginBottom: 2
                                }}
                                placement="top" isOpen={this.state["detail" + thisId]} target={"detail-" + thisId}
                                toggle={() => {
                                    this.setState({
                                        ["detail" + thisId]: !this.state["detail" + thisId]
                                    })
                                }}
                            >Detil</Tooltip>
                        </span>
                        {accessRole('update') && this.currentRoleId == 1 ?
                            <span>
                                <button
                                    className="btn btn-warning btn-sm"
                                    id={"update-" + thisId}
                                    onClick={() => {
                                        this.setState({
                                            updateUuid: record.position_history_uuid
                                        })
                                    }}
                                    style={{
                                        marginRight: '2px',
                                        padding: '2px 5px'
                                    }}>
                                    <i className="uil-pen"></i>
                                </button>
                                <Tooltip
                                    style={{
                                        marginBottom: 2
                                    }}
                                    placement="top" isOpen={this.state["update" + thisId]} target={"update-" + thisId}
                                    toggle={() => {
                                        this.setState({
                                            ["update" + thisId]: !this.state["update" + thisId]
                                        })
                                    }}
                                >Perbaharui</Tooltip>
                            </span>
                            : null
                        }
                        {accessRole('delete') && this.currentRoleId == 1 ?
                            <span>
                                {parseInt(status) === 1 ? (
                                    <span>
                                        <button
                                            className="btn btn-danger btn-sm"
                                            id={"delete-" + thisId}
                                            onClick={() => {
                                                this.modal_confirm_status = 1
                                                this.modal_confirm_message = "Apakah anda yakin akan menonaktifkan data ini ?"
                                                this.setState({
                                                    inactiveUuid: record.position_history_uuid,
                                                    confirm: true
                                                })
                                            }}
                                            style={{
                                                padding: '2px 5px'
                                            }}>
                                            <i className="uil-trash-alt"></i>
                                        </button>
                                        <Tooltip
                                            style={{
                                                marginBottom: 2
                                            }}
                                            placement="top" isOpen={this.state["delete" + thisId]} target={"delete-" + thisId}
                                            toggle={() => {
                                                this.setState({
                                                    ["delete" + thisId]: !this.state["delete" + thisId]
                                                })
                                            }}
                                        >Nonaktifkan
                                        </Tooltip>
                                    </span>
                                ) : (
                                    <span>
                                        <button
                                            className="btn btn-success btn-sm"
                                            id={"delete-" + thisId}
                                            onClick={() => {
                                                this.modal_confirm_status = 0
                                                this.modal_confirm_message = "Apakah anda yakin akan mengaktifkan data ini ?"
                                                this.setState({
                                                    inactiveUuid: record.position_history_uuid,
                                                    confirm: true
                                                })
                                            }}
                                            style={{
                                                padding: '2px 5px'
                                            }}>
                                            <i className="uil-check"></i>
                                        </button>
                                        <Tooltip
                                            style={{
                                                marginBottom: 2
                                            }}
                                            placement="top" isOpen={this.state["delete" + thisId]} target={"delete-" + thisId}
                                            toggle={() => {
                                                this.setState({
                                                    ["delete" + thisId]: !this.state["delete" + thisId]
                                                })
                                            }}
                                        >Aktifkan
                                        </Tooltip>
                                    </span>
                                )}
                            </span>
                            : null
                        }
                    </Fragment>
                );
            }
        }
    ]

    render() {
        return (
            <>
                <MKIDatatable
                    className={this.configDatatable.tableClass}
                    config={this.configDatatable}
                    records={this.state.rows}
                    columns={this.columns}
                    dynamic={true}
                    minWidth={1000}
                    total_record={this.state.totalRow}
                    initial={this.state.filter}
                    onChange={(filter) => {
                        this.setState({
                            loadingTable: true,
                            filter: filter
                        }, function () {
                            this.setTokenAPI()
                        });
                    }}
                    loading={this.state.loadingTable}
                />
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo={this.modal_confirm_message}

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo={this.modal_confirm_sucess_message}

                    failedTitle="Gagal!"
                    failedInfo={this.modal_confirm_error_message}

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                {this.state.detailUuid !== null ?
                    <Redirect to={"/kepegawaian/home.html?riwayatjabatan&detail&uuid=" + this.state.detailUuid} />
                    : null}
                {this.state.updateUuid !== null ?
                    <Redirect to={"/kepegawaian/home.html?riwayatjabatan&update&uuid=" + this.state.updateUuid} />
                    : null}
            </>
        )
    }

}

export default TableActiveComponent